import { render, staticRenderFns } from "./CreateAgencyPopup.vue?vue&type=template&id=9b6b5faa"
import script from "./CreateAgencyPopup.vue?vue&type=script&lang=js"
export * from "./CreateAgencyPopup.vue?vue&type=script&lang=js"
import style0 from "./CreateAgencyPopup.vue?vue&type=style&index=0&id=9b6b5faa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports